export default "__VITE_ASSET__BgUe7zXA__"